import { render, staticRenderFns } from "./metrics-row.vue?vue&type=template&id=1b46e3b6&"
import script from "./metrics-row.vue?vue&type=script&lang=js&"
export * from "./metrics-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports